import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {LocalDataSource} from 'ng2-smart-table';
import {Subscription} from 'rxjs';

@Component({
  selector: 'ngx-form-list',
  templateUrl: './form-list.component.html',
  styleUrls: ['./form-list.component.scss'],
})
export class FormListComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() columns: any;
  @Input() value: any[];
  @Input() canDelete: boolean = false;
  @Input() canEdit: boolean = true;
  @Input() canAdd: boolean = true;
  @Input() confirmDelete: boolean = false;
  @Input() sort: boolean = false;

  @Output() valueChange: EventEmitter<any[]> = new EventEmitter<any[]>();

  @Output() editConfirm: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteConfirm: EventEmitter<any> = new EventEmitter<any>();

  settings: any;

  source: LocalDataSource;

  subscription: Subscription;

  // gard to avoid circular updates
  changeCommited: boolean = false;

  constructor() {
  }

  ngOnInit() {
    this.settings = {
      actions: {
        position: 'right',
        columnTitle: '',
        delete: this.canDelete,
        edit: this.canEdit,
        add: this.canAdd,
      },
      add: {
        addButtonContent: '<i class="nb-plus"></i>',
        createButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
        confirmCreate: true,
      },
      edit: {
        editButtonContent: '<i class="nb-edit"></i>',
        saveButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
        confirmSave: true,
      },
      delete: {
        deleteButtonContent: '<i class="nb-trash"></i>',
        confirmDelete: this.confirmDelete,
      },
      columns: this.columns,
      filter: {
        inputClass: 'filter',
      },
      sort: this.sort,
      compareFunction: (a, b) => a.sort - b.sort,
    };
    this.reload(this.value);
    this.source.setSort([{ field: 'sort', direction: 'asc' }]);
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (this.settings && (changes.canAdd || changes.canDelete || changes.canEdit)) {
      this.settings.actions.add = this.canAdd;
      this.settings.actions.edit = this.canEdit;
      this.settings.actions.delete = this.canDelete;
      // hack for add TODO: find reason in ng2-smart-table source
      const headers = document.getElementsByClassName('ng2-smart-filters');
      [].forEach.call(headers, (header) => {
        header.style.display = this.canAdd ? 'contents' : 'none';
      })
      this.reloadSettings(this.settings);
    } else {
      if (!this.changeCommited && changes.value != null)
        this.reload(changes.value.currentValue);
      this.changeCommited = false;
    }
  }

  showActions(actions: any) {
    this.settings.actions = actions;
    this.reloadSettings(this.settings);
  }

  reloadColumns(columns: any, sale = true) {
    this.columns = columns;
    this.columns.validFrom.editor.config.acc = sale ? 'sale' : 'purchase';
    this.columns.validTo.editor.config.acc = sale ? 'sale' : 'purchase';
    this.reloadSettings(this.settings);
  }

  reloadSettings(settings: any = this.settings) {
    const copy = Object.assign({}, settings);
    this.settings = copy;
    // console.log(this.settings);
  }

  reload(value: any[]) {
    if (this.source == null) this.source = new LocalDataSource([]);
    if (this.subscription != null) this.subscription.unsubscribe();
    this.changeCommited = true;
    this.source.load(value || []).then(() => {
      this.subscription = this.source.onChanged().subscribe((v) => {
        this.changeCommited = true;
        this.source.getAll().then((elements) => {
          this.valueChange.emit(elements);
        })
        // console.log(value);
      });
    });

  }

  update(event) {
    // console.log(event);
    // this.valueChange.emit(this.value);
  }

/*  addElement() {
    if (this.value == null) this.value = [];
    this.value.push(this.newElement);
    this.updateValue(this.value);
    this.newElement = '';
  }

  removeElement(element: string) {
    const idx = this.value.indexOf(element);
    if (idx >= 0) {
      this.value.splice(idx, 1);
      this.updateValue(this.value);
    }
  }*/
}
